import DrawerMenuMobile from "@core/layouts/header/components/mobile/DrawerMenuMobile";
import Logo from "@core/layouts/header/components/common/Logo";
import UserMobile from "@core/layouts/header/components/mobile/UserMobile";
import CnbMobile from "@core/layouts/header/components/mobile/CnbMobile";
import { cn } from "@core/utils/domUtil";

export default function HeaderMobile({ isLoginLoading }: { isLoginLoading: boolean }) {
  return (
    <>
      <div className={cn("flex h-[var(--mobile-header-height)] items-center justify-between px-[10px]")}>
        <DrawerMenuMobile />
        <Logo />
        <UserMobile />
      </div>
      <CnbMobile />
    </>
  );
}
